

import { Indicator } from 'mint-ui';
import myToast from '../components/my_toast.vue'

let $vm

export default {
  install: (Vue, option) => {
    // 添加实例方法

    if (!$vm) {
      const ToastPlugin = Vue.extend(myToast)

      $vm = new ToastPlugin({
        el: document.createElement('div')
      })

      document.body.appendChild($vm.$el)
    }
    Vue.prototype.$myToast = $vm.toast
    Vue.prototype.$loading = Indicator
  }
}

